import { DashboardPeriodPreset, IVisitPeriod, OfferStatusFilter } from "../types/ownerDashboard.types";
import { getAllTimePeriod } from "./getAllTimePeriod";

export interface OwnerOffersQuery {
  periodPreset: DashboardPeriodPreset;
  customPeriod?: IVisitPeriod | null;
  propertyId?: number | null;
  historyYears?: number;
  page?: number;
  perPage?: number;
  statusFilter?: OfferStatusFilter;
}

export function buildOwnerOffersParams(
  query: OwnerOffersQuery
): Record<string, string> {
  const params: Record<string, string> = {};

  if (query.customPeriod) {
    params.initial_date = query.customPeriod.initial_date;
    params.final_date = query.customPeriod.final_date;
  } else if (query.periodPreset === "all_time") {
    const allTimeRange = getAllTimePeriod(new Date(), query.historyYears);
    params.initial_date = allTimeRange.initial_date;
    params.final_date = allTimeRange.final_date;
  } else {
    params.period = query.periodPreset;
  }

  if (query.propertyId != null) {
    params.property_id = String(query.propertyId);
  }

  if (query.statusFilter) {
    params.status = query.statusFilter;
  }

  if (query.page != null) {
    params.page = String(query.page);
  }

  if (query.perPage != null) {
    params.per_page = String(query.perPage);
  }

  return params;
}
